// extracted by mini-css-extract-plugin
module.exports = {"container":"Proffits_container__1UiPY","item":"Proffits_item__3e9sq","selected":"Proffits_selected__2F6ZI"};